export function formatVariablesForTextInput(variables) {
    return variables
        .flatMap(({ items }) => items)
        .filter(({ name }) => !!name)
        .map(({ content, name }) => ({
        key: name,
        label: content,
        searchableName: content,
    }));
}
